import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { PageContainer } from "@/components/pages_flexible/PageContainer";

import { PermissionError } from "./PermissionError";

export function PermissionErrorPage() {
  return (
    <>
      <SEOHead
        title="Access Restricted"
        description="Sorry, but you don't have permission to access this page. Perhaps check the URL for typos."
      />
      <PageContainer sizeNavBreakpoint="md" layout="marketing">
        <PermissionError />
      </PageContainer>
    </>
  );
}
